<template>
  <nav
    id="navbarExample"
    aria-label="Main navigation"
    class="navbar navbar-expand-lg fixed-top navbar-light custom-navbar"
    :class="{ 'top-nav-collapse': isCollapsed }"
  >
    <div class="container">
      <a class="navbar-brand logo-text" href="#">
        <img :src="require('@/assets/logo.png')" alt="logoDiskola" class="img_logo" />
        <span>diskola.id</span>
      </a>
      <button
        id="navbarSideCollapse"
        aria-label="Toggle navigation"
        class="navbar-toggler p-0 border-0"
        type="button"
        :aria-expanded="isMenuOpen"
        @click="toggleMenu"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        id="navbarsExampleDefault"
        class="navbar-collapse offcanvas-collapse custom-navbar__collapse flex-lg-grow-1"
        :class="{ open: isMenuOpen }"
      >
        <div class="custom-navbar__collapse-inner">
          <ul class="navbar-nav navbar-nav-scroll custom-navbar__nav-links">
            <li class="nav-item">
              <router-link aria-current="page" class="nav-link" to="/" @click="closeMenu">Beranda</router-link>
            </li>
            <li class="nav-item">
              <router-link aria-current="page" class="nav-link" to="/produk" @click="closeMenu">Produk</router-link>
            </li>
            <li class="nav-item">
              <router-link aria-current="page" class="nav-link" to="/kebijakan-privasi" @click="closeMenu">
                Kebijakan &amp; Privasi
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav custom-navbar__nav-cta">
            <li class="nav-item custom-navbar__theme-item">
              <button
                type="button"
                class="theme-toggle"
                :aria-label="theme === 'dark' ? 'Ganti ke tema terang' : 'Ganti ke tema gelap'"
                :aria-pressed="theme === 'dark'"
                @click="toggleTheme"
              >
                <svg
                  v-if="theme === 'dark'"
                  class="theme-toggle__icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  width="18"
                  height="18"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="4" />
                  <path
                    d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32 1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
                  />
                </svg>
                <svg
                  v-else
                  class="theme-toggle__icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  width="18"
                  height="18"
                  aria-hidden="true"
                >
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                </svg>
              </button>
            </li>
            <li class="nav-item custom-navbar__cta-item">
              <a
                class="navbar-contact-cta"
                :href="whatsappUrl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="navbar-contact-cta__icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path
                      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
                    />
                  </svg>
                </span>
                <span class="navbar-contact-cta__label">Kontak kami</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { useTheme } from "@/composables/useTheme";
import { getWhatsAppUrl } from "@/services/whatsapp";

export default {
  name: "NavbarHeader",
  setup() {
    const { theme, toggleTheme } = useTheme();
    return { theme, toggleTheme };
  },
  data() {
    return {
      isMenuOpen: false,
      isCollapsed: false,
      ticking: false,
      whatsappUrl: getWhatsAppUrl(),
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    updateCollapsedState() {
      this.isCollapsed = window.scrollY > 30;
      this.ticking = false;
    },
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(this.updateCollapsedState);
    },
  },
  mounted() {
    if (typeof window === "undefined") return;
    this.updateCollapsedState();
    window.addEventListener("scroll", this.onScroll, { passive: true });
  },
  beforeUnmount() {
    if (typeof window === "undefined") return;
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/tokens";

.custom-navbar {
  background-color: rgba(var(--surface-rgb), 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: var(--shadow-sm);
  padding: 15px 0;
  transition: all var(--dur-base) var(--ease-out);
}

.custom-navbar.top-nav-collapse {
  padding: 10px 0;
  background-color: rgba(var(--surface-rgb), 0.95);
  box-shadow: var(--shadow-md);
}

[data-theme="dark"] .custom-navbar {
  background-color: rgba(var(--surface-rgb), 0.88);
}

/* Bootstrap navbar-light hamburger tak terlihat di dark — pakai currentColor */
[data-theme="dark"] .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(226, 232, 240, 0.9)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

.img_logo {
  width: 35px;
  margin-right: 8px;
}

.logo-text {
  display: flex;
  align-items: center;
  text-decoration: none;

  span {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 20px;
    color: var(--color-primary);
    letter-spacing: -0.5px;
  }
}

/* Susun ulang: link di tengah (desktop), CTA terpisah di kanan — selaras tema & offcanvas */
.offcanvas-collapse {
  @media (max-width: 991.98px) {
    position: fixed;
    top: 3.25rem;
    bottom: 0;
    left: 100%;
    width: 100%;
    padding-right: 1rem;
    padding-left: 1rem;
    overflow-y: auto;
    visibility: hidden;
    background-color: var(--surface-elevated);
    transition: transform 0.3s ease-in-out, visibility 0.3s ease-in-out;
    z-index: 1030;

    &.open {
      visibility: visible;
      transform: translateX(-100%);
    }
  }

  @media (min-width: 992px) {
    position: static;
    top: auto;
    bottom: auto;
    left: auto;
    width: auto;
    padding-right: 0;
    padding-left: 0;
    overflow-y: visible;
    visibility: visible;
    background-color: transparent;
    transform: none;

    &.open {
      transform: none;
    }
  }
}

.custom-navbar__collapse-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (min-width: 992px) {
    position: relative;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    flex: 1 1 auto;
    min-height: 2.75rem;
  }
}

.custom-navbar__nav-links.navbar-nav {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  .nav-item {
    margin: 0 8px;
  }

  .nav-link {
    font-family: "Inter", sans-serif;
    font-weight: 500;
    color: var(--text);
    font-size: 15px;
    padding: 8px 16px;
    border-radius: 20px;
    transition: all var(--dur-base) var(--ease-out);
    display: inline-flex;
    align-items: center;

    &:hover,
    &.router-link-active {
      color: var(--color-primary);
      background-color: var(--color-primary-soft);
    }
  }

  @media (max-width: 991.98px) {
    width: 100%;
    margin-top: 0.75rem !important;
    margin-bottom: 0 !important;
    padding-bottom: 0.25rem;

    .nav-item {
      margin: 0.2rem 0;
      width: 100%;
      text-align: center;
    }

    .nav-link {
      justify-content: center;
      width: 100%;
    }
  }

  @media (min-width: 992px) {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin: 0 !important;
    flex-wrap: nowrap;
  }
}

.custom-navbar__nav-cta.navbar-nav {
  @media (max-width: 991.98px) {
    width: 100%;
    margin-top: 0.25rem !important;
    margin-bottom: 1rem !important;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: 992px) {
    margin: 0 0 0 auto !important;
    padding-left: 1rem;
    margin-left: 1rem !important;
    border-left: 1px solid var(--border-neutral);
    gap: 0.6rem;
    align-items: center;
    flex-shrink: 0;
  }
}

.custom-navbar__theme-item.nav-item {
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 991.98px) {
    margin-bottom: 0.75rem !important;
  }
}

.theme-toggle {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid var(--border-neutral);
  background-color: transparent;
  color: var(--text);
  cursor: pointer;
  transition: background-color var(--dur-fast) var(--ease-out),
    color var(--dur-fast) var(--ease-out),
    transform var(--dur-fast) var(--ease-out);

  &:hover {
    color: var(--color-primary);
    background-color: var(--color-primary-soft);
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 2px;
  }

  &__icon {
    transition: transform var(--dur-base) var(--ease-out);
  }

  &:active &__icon {
    transform: rotate(40deg) scale(0.9);
  }
}

.custom-navbar__cta-item.nav-item {
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar-contact-cta {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.45rem 1.1rem 0.45rem 0.45rem;
  border-radius: 999px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 0.9375rem;
  letter-spacing: -0.01em;
  color: #ffffff !important;
  text-decoration: none !important;
  background: linear-gradient(135deg, #04606c 0%, #034c56 100%);
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: 0 4px 16px rgba(var(--color-primary-rgb), 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.12);
  transition: transform var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out);

  &:hover {
    color: #ffffff !important;
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(var(--color-primary-rgb), 0.38), inset 0 1px 0 rgba(255, 255, 255, 0.15);
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 3px;
  }

  &__icon {
    display: grid;
    place-items: center;
    flex-shrink: 0;
    width: 2.1rem;
    height: 2.1rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.98);
    color: var(--color-whatsapp);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  }

  &__label {
    padding-right: 0.15rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .navbar-contact-cta {
    transition: none;

    &:hover {
      transform: none;
    }
  }
}
</style>
